import { buildUrl, usKidsGolfService } from '@/libs/api/instances/us-kids-golf-instance';
import type { RequestOptions } from '@/libs/api/types';

import type { PlayerGuardian } from './get-player-guardians';

/** Path (relative to `buildUrl`) for sending a co-guardian invitation. */
export const playerInvitationsEndpoint = (playerId: string) =>
  `/guardians/me/players/${playerId}/invitations`;

/** Body for POST /api/v1/guardians/me/players/{playerId}/invitations. */
export type InvitePlayerGuardianRequest = {
  /** Email of the person being invited. */
  invitedEmail: string;
  /** Relationship to the player, e.g. "parent" | "grandparent" | "coach" | "other". */
  relationship: string;
  /** Optional personal note included in the invitation. */
  message?: string;
  /** Ask the server to return the refreshed circle in the response. */
  refresh?: boolean;
};

/**
 * Invites a guardian to co-manage a player (owner only) via
 * POST `/api/v1/guardians/me/players/{playerId}/invitations`. With `refresh: true`
 * the server returns the refreshed circle (active members + outstanding invitations).
 */
export async function invitePlayerGuardian(
  playerId: string,
  body: InvitePlayerGuardianRequest,
  options?: RequestOptions,
): Promise<PlayerGuardian> {
  return await usKidsGolfService.post<PlayerGuardian, InvitePlayerGuardianRequest>(
    buildUrl(playerInvitationsEndpoint(playerId)),
    body,
    options,
  );
}
